import axios from "axios";
import { ENDPOINT_USERS, ENDPOINT_USERS_CASA, ENDPOINT_USERS_DEVICES, ENDPOINT_USERS_DEVICE_REMOVE, ENDPOINT_USERS_DEVICE_STATUS, ENDPOINT_USERS_LOAN, ENDPOINT_USERS_SCA, ENDPOINT_USERS_TD, ENDPOINT_USERS_DELETE, ENDPOINT_USERS_BLOCK, ENDPOINT_USERS_UNBLOCK } from "../../constants";
import { BankAccountInfo, ClientInfo, DeviceInfo, LoanInfo } from "./data";
import { ApiResponse } from "../types";
import { handleApiError, apiCallWithRetry } from "../../utils/error_handler";

export async function retrieveUsers(offset:number, limit:number, query=""): Promise<ClientInfo[] | null> {
    try {
        const res = await apiCallWithRetry(() => 
            axios.get<ApiResponse<ClientInfo[]>>(ENDPOINT_USERS + "?query="+query+"&offset="+offset+"&limit="+limit)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as ClientInfo[] || null;
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function retrieveCasa(client:string): Promise<BankAccountInfo[]> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<BankAccountInfo[]>>(ENDPOINT_USERS_CASA + "?client="+client)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as BankAccountInfo[] || [];
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function retrieveTD(client:string):Promise<BankAccountInfo[]> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<BankAccountInfo[]>>(ENDPOINT_USERS_TD + "?client="+client)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as BankAccountInfo[] || [];
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function retrieveSCA(client:string):Promise<BankAccountInfo[]> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<BankAccountInfo[]>>(ENDPOINT_USERS_SCA + "?client="+client)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as BankAccountInfo[] || [];
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function retrieveLoan(client:string):Promise<LoanInfo[]> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<LoanInfo[]>>(ENDPOINT_USERS_LOAN + "?client="+client)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as LoanInfo[] || [];
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function retrieveDevices(clientId:string):Promise<DeviceInfo[]> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<DeviceInfo[]>>(ENDPOINT_USERS_DEVICES + "?clientId="+clientId)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as DeviceInfo[] || [];
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function deleteUser(userId:string):Promise<string> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<string>>(ENDPOINT_USERS_DELETE + "?userId="+userId)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as string || "success";
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function blockUser(clientId:string):Promise<string> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<string>>(ENDPOINT_USERS_BLOCK + "?clientId="+clientId)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as string || "success";
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function unblockUser(clientId:string):Promise<string> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<string>>(ENDPOINT_USERS_UNBLOCK + "?clientId="+clientId)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as string || "success";
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function removeDevice(clientId:string, deviceId:string):Promise<string> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<string>>(ENDPOINT_USERS_DEVICE_REMOVE + "?clientId="+clientId+"&deviceId="+deviceId)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as string || "success";
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function updateDeviceStatus(clientId:string, deviceId:string, status:string):Promise<string> {
    try {
        const res = await apiCallWithRetry(() =>
            axios.get<ApiResponse<string>>(ENDPOINT_USERS_DEVICE_STATUS + "?clientId="+clientId+"&deviceId="+deviceId+"&status="+status)
        );
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as string || "success";
    } catch (error: any) {
        throw handleApiError(error);
    }
}